import { render } from "./GetNoRackList.vue?vue&type=template&id=1a96be3b"
import script from "./GetNoRackList.vue?vue&type=script&lang=js"
export * from "./GetNoRackList.vue?vue&type=script&lang=js"
script.render = render

export default script